import { useApplicationStore } from '@/store/applicationStore';
import { apiGet } from '../../../store/api';

export async function getVarcharColumns() {
  const data = await apiGet('application/varcharColumns');
  useApplicationStore().setVarcharColumns(data);
}
